import { http } from '@pendo/http';

export function getUpdateEmail (vocItemId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/email`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getVocItemEmailUpdates (vocItemId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getVocItemEmailUpdateContent (vocItemId, vocEmailUpdateId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/${vocEmailUpdateId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getVocEmailTemplates () {
    return http
        .get('/api/s/_SID_/voc/layout')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteVocEmailTemplates ({ templateId }) {
    return http.delete(`/api/s/_SID_/voc/layout/${templateId}`).catch((err) => {
        throw err;
    });
}

export function createEmailTemplate ({
    name,
    subjectLine,
    bodyContent,
    bannerImageUrl,
    footerImageUrl,
    themeId,
    appId,
    status,
}) {
    return http
        .post('/api/s/_SID_/voc/layout', {
            name,
            tags: 'isVoc, isWeb',
            themeId,
            buildingBlocks: {},
            supportedPlatforms: { web: true },
            attributes: {
                vocEmail: {
                    subjectLine,
                    bodyContent,
                    bannerImageUrl,
                    footerImageUrl,
                    appId,
                    status,
                },
            },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateEmailTemplate ({
    templateId,
    name,
    subjectLine,
    bodyContent,
    bannerImageUrl,
    footerImageUrl,
    themeId,
    appId,
    status,
}) {
    return http
        .put(`/api/s/_SID_/voc/layout/${templateId}`, {
            name,
            tags: 'isVoc, isWeb',
            themeId,
            buildingBlocks: {},
            supportedPlatforms: { web: true },
            attributes: {
                vocEmail: {
                    subjectLine,
                    bodyContent,
                    bannerImageUrl,
                    footerImageUrl,
                    appId,
                    status,
                },
            },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateEmailStatus ({ pinpointId, status }) {
    return http
        .put(`/api/s/_SID_/omnichannel/${pinpointId}/email/status`, {
            status,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function saveEmailDraft ({
    vocItemId,
    vocEmailUpdateId,
    emailProfileId,
    appId,
    steps,
    layoutAttributes,
    autoSendToNewSubscribers,
}) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/campaign`, {
            autoSendToNewSubscribers,
            emailProfileId,
            subject: layoutAttributes.subjectLine,
            vocEmailUpdateId,
            appId,
            steps,
            layoutAttributes,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getVocItemEmailDraft ({ vocItemId, draftEmailId }) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/${draftEmailId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getPublicCampaigns (vocItemId, vocEmailUpdateId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/${vocEmailUpdateId}/publicCampaigns`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
